module.exports = __webpack_public_path__ + "static/media/spicy.350100f1.png";